import { Box, Paper, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';

type PrototypeCardProps = {
  style?: CSSProperties;
  children: ReactNode;
  className?: string;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      padding: theme.spacing(1),
      border: `1px solid ${theme.palette.grey[200]}`,
      boxShadow: theme.shadows[1],
      backgroundColor: theme.palette.white,
    },
    content: {
      border: `1px dotted ${theme.palette.grey[300]}`,
      padding: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
      height: '100%',
    },
  }),
  { name: 'PrototypeCard' },
);

export const PrototypeCard = ({
  style,
  children,
  className,
}: PrototypeCardProps) => {
  const classes = useStyles();
  return (
    <Paper className={clsx(classes.root, className)} style={style}>
      <Box className={classes.content}>{children}</Box>
    </Paper>
  );
};
